"use client";

import { Button } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import {
  EditableBeatRow,
  type EditableBeatRowProps,
} from "./editable-beat-row";
import type { EditableBeat, EditorBeat } from "./beat-records";
import { beatStyles as styles } from "./beats.stylex";

type EditableBeatsViewProps =
  | Readonly<{ mode: "read"; beats: readonly EditorBeat[] }>
  | Readonly<{
      mode: "edit";
      loading: boolean;
      minBeats: number;
      maxBeats: number;
      maxTitleLength: number;
      maxBodyLength: number;
      beats: readonly EditableBeat[];
      fitPreview(text: string): string | null;
      onUpdate: EditableBeatRowProps["onUpdate"];
      onAdd(): void;
      onRemove(index: number): void;
    }>;

export function EditableBeatsView(props: EditableBeatsViewProps) {
  return (
    <div {...stylex.props(styles.stack)}>
      <ol {...stylex.props(styles.list)}>
        {props.mode === "read"
          ? props.beats.map((beat, index) => (
              <li key={index} {...stylex.props(styles.beat)}>
                <span {...stylex.props(styles.number)}>
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div {...stylex.props(styles.content)}>
                  <p {...stylex.props(styles.title)}>{beat.title}</p>
                  <p {...stylex.props(styles.body)}>{beat.body}</p>
                </div>
              </li>
            ))
          : props.beats.map((beat, index) => (
              <EditableBeatRow
                key={index}
                beat={beat}
                index={index}
                loading={props.loading}
                maxTitleLength={props.maxTitleLength}
                maxBodyLength={props.maxBodyLength}
                fitPreview={props.fitPreview}
                onUpdate={props.onUpdate}
                onRemove={props.onRemove}
              />
            ))}
      </ol>
      {props.mode === "edit" ? (
        <div {...stylex.props(styles.actions)}>
          <Button
            size="sm"
            onClick={props.onAdd}
            disabled={props.loading || props.beats.length >= props.maxBeats}
          >
            Add beat
          </Button>
          <span {...stylex.props(styles.caption)}>
            {props.beats.length}/{props.maxBeats} · at least {props.minBeats} to
            publish
          </span>
        </div>
      ) : null}
    </div>
  );
}
